// extracted by mini-css-extract-plugin
export var boxItems = "_82-1";
export var button = "_82-5";
export var filterGroupBox = "_82-0";
export var icon = "_82-2";
export var iconSecondary = "_82-4";
export var iconWrapper = "_82-3";